module.exports = __webpack_public_path__ + "img/771-68e5cf.png";